import layout from '@/layout'

export default {
  path: '/marketing',
  component: layout,
  redirect: '/marketing/coupon_send_activity',
  name: 'marketingCouponSendActivity',
  meta: {
    title: 'marketing',
    icon: 'el-icon-box'
  },
  children: [
    {
      path: '/marketing/coupon_send_activity',
      name: 'marketingCouponSendActivity',
      component: () => import('@/views/coupon_send_activity/index'),
      meta: {
        title: 'marketingCouponSendActivity',
        icon: 'el-icon-box'
      }
    }
  ]
}
